module.exports = __webpack_public_path__ + "img/aftersales-group-empty.e25c42c3.png";